import "./ForgetPassAccept.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UsersActiveForgetPass, UsersRegister } from "../../Api/Services";
import { toast } from "react-toastify";

function ForgetPassAccept() {
  const [inputValue, setInputValue] = useState({});
  const [flagLoading, setFlagLoading] = useState(false);

  const navigate = useNavigate();

  const LoginCheck = async () => {
    let validation = true;
    if (inputValue.userName === "") {
      toast.error("شماره همراه را وارد نمایید ");
      validation = false;
    }
    if (inputValue.pass === "") {
      toast.error("رمز عبور  را وارد نمایید ");
      validation = false;
    }
    if (inputValue.code === "") {
      toast.error("  کد  را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setFlagLoading(true);
      try {
        const UsersActiveForgetPassData = await UsersActiveForgetPass(
          inputValue
        );
        if (
          UsersActiveForgetPassData.status &&
          UsersActiveForgetPassData.status === 200
        ) {
          toast.success("رمز عبور جدید ثبت شد");
          navigate("/Login");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setFlagLoading(false);
      }
    }
  };
  const loginByEnter = (e) => {
    if (e.key === "Enter") {
      LoginCheck();
    }
  };

  return (
    <>
      {flagLoading && (
        <div
          className="scopeLoading d-flex justify-content-center align-items-center"
          style={{ height: window.innerHeight }}
        >
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={flagLoading ? "startLoading" : "stateLoading"}>
        <div className="d-flex justify-content-center align-items-center">
          <div id="loginForm">
            <h2 className="text-center w-100 mt-2">ثبت رمز عبور جدید</h2>
            <div className="p-5" onKeyPress={loginByEnter}>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="شماره همراه"
                  value={inputValue.username}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      username: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="password"
                  placeholder="رمز عبور"
                  value={inputValue.pass}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      pass: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="کد تایید"
                  value={inputValue.code}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      code: e.target.value,
                    });
                  }}
                />
              </div>

              <div className="d-flex justify-content-center">
                <button className="loginButton mt-3" onClick={LoginCheck}>
                  احراز
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetPassAccept;
